import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from '../environments/environment';
import { LanguageService } from './services/language.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent implements OnInit {
  title = 'boardBillCentrix';
  private floatingUrl: string = environment.versionAnteriorUrl;
  readonly chatbotEnabled = environment.chatbotEnabled;

  constructor(private languageService: LanguageService, public readonly router: Router) {
    // Inicializar el sistema de idiomas al cargar la aplicación
    this.languageService.initLanguage();
  }

  ngOnInit(): void {
    // migración auth v2: claves que ya no se usan
    ['pinValidated', 'isAdmin', 'loginUsername', 'tokenRefreshCount']
      .forEach(key => localStorage.removeItem(key));
  }

  goFloatingLink(): void { window.open(this.floatingUrl, '_blank', 'noopener'); }
}
